import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { SeverityType } from 'common-types';
import { IssueDetails } from '../../types/issues-types';
import SeverityColor from '../SeverityColor';
import { mappingSeveritisChangeReason } from '../../utils/issue-utils';
import SeverityChangeFactor from './SeverityChangeFactor';

const IssueCardSeverity: FC<IssueCardSeverityProps> = ({
  severity,
  originalSeverity,
  severityBreakdown,
}) => {
  const { classes } = useStyles();
  const showOriginalSeverity = !originalSeverity ? severity : originalSeverity;
  const severitiesByType = mappingSeveritisChangeReason(severityBreakdown);
  return (
    <div className={classes.issueCardSeverity}>
      <div className={classes.textContainer}>
        <Typography variant='h1' color='text.secondary'>
          Severity&nbsp;
          <SeverityColor severity={severity}>
            {color => (
              <span
                style={{ color, textTransform: 'uppercase', fontWeight: 600 }}>
                {severity}
              </span>
            )}
          </SeverityColor>
        </Typography>

        <Typography variant='body2' color='text.secondary'>
          Original&nbsp;
          <SeverityColor severity={showOriginalSeverity}>
            {color => (
              <span
                style={{
                  color,
                  textTransform: 'uppercase',
                  fontWeight: 600,
                }}>
                {showOriginalSeverity}
              </span>
            )}
          </SeverityColor>
        </Typography>
      </div>
      <SeverityChangeFactor severitiesByType={severitiesByType} />
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  issueCardSeverity: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(1),
  },
}));

export interface IssueCardSeverityProps {
  severity: SeverityType;
  originalSeverity: SeverityType;
  severityBreakdown: IssueDetails['severityBreakdown'];
}

export default IssueCardSeverity;
